import AuthService from './AuthService';
import ApiService from "./ApiService";

class ProfileProductsService extends ApiService{
    constructor(authService) {
        super();
        this._authService = authService;
        this._locale = 'ru';
        this._initialUrl = '/profile/products/initial';
        this._productsUrl = '/profile/products';
        this._removeUrl = '/profile/products/delete';
        this._tableDataUrl = '/profile/products/table-data';
        this._updateUrl = '/profile/products/update';
    }

    remove(id) {
        return this.postResource(this._removeUrl, {id}, this.getBaseHeaders())
    }

    getBaseHeaders() {
        const langHeader = this._locale ? {'X-Localization' : this._locale} : {};
        const authHeader = this._authService.getAuthHeader();

        return {...authHeader, ...langHeader};
    }

    getProducts(params) {
        return this.postResource(this._productsUrl, params, this.getBaseHeaders())
    }

    getInitial(id) {
        return this.postResource(this._initialUrl, {id}, this.getBaseHeaders())
    }

    getTableData() {
        return this.postResource(this._tableDataUrl, {}, this.getBaseHeaders())
    }

    updateParam(param, data) {
        const url = this._updateUrl + '/' + param;

        return this.postResource(url, data, this.getBaseHeaders());
    }

    updateProduct(data) {
        const headers = {...this.getBaseHeaders(), 'Content-Type': 'multipart/form-data'};
        return this.postResource(this._updateUrl, data, headers);
    }
}

const service = new ProfileProductsService(AuthService);

export default service;
